
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M23.53 4.12L25.11 5.7c.16.16.16.42 0 .578l-8.336 8.336 8.337 8.336c.158.159.158.419-.001.578l-1.582 1.582c-.159.159-.42.159-.578 0l-8.336-8.336-7.336 7.336c-.159.16-.418.159-.578 0L5.12 22.529c-.16-.16-.16-.419-.001-.578l7.336-7.336-7.336-7.336c-.16-.16-.158-.419 0-.578L6.702 5.12c.16-.159.42-.16.578 0l7.336 7.335 8.336-8.335c.159-.159.42-.159.578 0z","transform":"translate(-650 -359) translate(228 344) translate(422 15)"}})])])])])])
          )
        }
      }
    